<template>
    <a
        v-if="activePanel"
        class="header-icon"
        href="#"
        :title="titlePanel"
        data-toggle="tooltip-city"
        @click.prevent="togglePanel">
        <i class="far fa-clock"></i>
        <span class="badge badge-icon" v-if="number>0">
            {{ number }}
        </span>
    </a>
</template>

<script>
    import ComponentMixin from '../mixins/ComponentMixin';

    export default {
        name: "overdueHeaderTool",
        mixins: [
            ComponentMixin,
        ],
        props: {
            propIdPanel: {
                type: String,
                default: 'overdue'
            },
        },
        data() {
            return {
                idPanel: this.propIdPanel,
            }
        },
        computed: {
            summary() {
                return this.panel.summary;
            },
            number() {
                let item = this.summary.find( item => item.titleTemplate);
                return item ? item.num : 0;
            },
            titlePanel() {
                let item = this.summary.find( item => item.titleTemplate);
                if(item && item.num>0){
                    return this.$t(item.titleTemplate, {number: item.num});
                }
                return this.title;
            },
        },
    };
</script>